<template>
  <div>
    <!-- 限于托管班 -->
    <div class="tuolele-main-box">
      <select-box :selects="itemSelects" :post-form.sync="listQuery" @search="$refs.itemselectlisttable.fetchTableData()" />
      <wq-table ref="itemselectlisttable" show-page sub-key="list" :other-query="listQuery" :url-func="$http.getItemList">
        <el-table-column prop="item_id" label="套餐ID" align="center" />
        <el-table-column prop="name" label="套餐名称" align="center" />
        <el-table-column prop="type_name" label="类型" align="center" />
        <el-table-column prop="total_price" label="实际销售价" align="center">
          <template slot-scope="{row}">
            ￥{{ row.total_price/100 }}元
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button v-if="selected != row.item_id" type="primary" @click="handleSelectionChange(row)">选择</el-button>
            <el-button v-if="selected == row.item_id" disabled>原套餐</el-button>
          </template>
        </el-table-column>
      </wq-table>
    </div>
  </div>
</template>

<script>
// import TeachingTypeSelect from '@/components/Select/TeachingTypeSelect'
import SelectBox from '@/components/SelectBox'
import WqTable from '@/components/WqTable'
import commondata from '@/utils/commondata'

export default {
  name: 'SelectPackageList',
  components: {
    // TeachingTypeSelect
    SelectBox,
    WqTable
  },
  props: {
    subId: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Number],
      default: ''
    },
    selected: {
      type: String,
      default: ''
    },
    excludes: {
      type: Array,
      default: () => []
    }
  },
  /**
     * @description 组件数据对象
     * @returns {Object} 返回组件所需的响应式数据对象
     */
  data() {
    return {
      itemSelects: [
        { type: 'select', dataFunc: () => {
          return new Promise((resolve) => {
            this.$http.getOrderType().then(res => {
              const objs = Object.entries(res.data).map(([id, name]) => ({ id, name }))

              resolve({ data: objs })
            })
          })
        }, bindValue: 'item_type', placeholder: '适用店铺' },
        { type: 'select', columns: commondata.GRADE_LISTS, bindValue: 'grade_id', placeholder: '适用年级' },
        { type: 'input', bindValue: 'item_title', placeholder: '套餐名称' }

      ],
      itemList: [],
      selectIndex: -1,
      listQuery: {
        item_type: '',
        grade_id: '',
        limit: 10,
        item_title: '',
        is_delete: 0
      }
    }
  },

  mounted() {

  },
  methods: {

    handleSelectionChange(row, index) {
      this.selectIndex = index
      this.$emit('selectPackage', {
        ...row
      })
    }

  }
}
</script>
<style lang="scss" scoped>

</style>
